import { Component, OnDestroy, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { debounceTime, Subject, Subscription } from "rxjs";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { DateUtil } from "../../util/date.util";
import { EventManager } from "../../../core";
import { Constant } from "../../../core/constant";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "filter-start-end-date",
  templateUrl: "./filter-start-end-date.html",
  styleUrls: ["./filter-start-end-date.scss"],
})
export class FilterStartEndDateComponent implements OnInit, OnChanges, OnDestroy {
  @Input("title") title: any;
  @Input("titleStart") titleStart: string = "Từ ngày";
  @Input("titleEnd") titleEnd: string = "Đến ngày";
  @Input("startDate") startDate: number;
  @Input("endDate") endDate: number;
  @Input("isDefaultData") isDefaultData: boolean = false;
  @Input("isDisabledStart") isDisabledStart: boolean = false;
  @Input("isDisabledEnd") isDisabledEnd: boolean = false;
  @Input("isRequired") isRequired: boolean;
  @Input("isValidated") isValidated: boolean;
  @Input("isNoFuture") isNoFuture: boolean = true;
  @Input("isNoPast") isNoPast: boolean = false;
  
  formDate: FormGroup = this.formBuilder.group({
    startDate: [null],
    endDate: [null],
  });
  Constant = Constant;
  subscriptions: Subscription[];
  isDevice: boolean = false;
  broadcastChange$ = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    public eventManager: EventManager,
    private breakpointObserver: BreakpointObserver,
  ) {}
  ngOnInit() {
    this.subscriptions = [
      ...[
        this.broadcastChange$.pipe(
          debounceTime(500),
          ).subscribe((event)=> { return this.broadcastData();}),
        this.eventManager.subscribe("reset-data-filter", (res) => {
          this.setDefault();
        }),
        this.formDate.get("startDate").valueChanges.subscribe((val) => {
          if (new Date(this.startDate).getTime() === new Date(val).getTime()) {
            return;
          }
          const startDate = !val ? null :
            DateUtil.revertDate(DateUtil.parseDate(val, 'dd/MM/yyyy') + ", 00:00:00", "dd/MM/yyyy, HH:mm:ss");
          this.startDate = startDate ? startDate.getTime() : null;
          this.broadcastChange$.next(true);
        }),
        this.formDate.get("endDate").valueChanges.subscribe((val) => {
          if (new Date(this.endDate).getTime() === new Date(val).getTime()) {
            return;
          }
          const endDate = !val ? null :
            DateUtil.revertDate(DateUtil.parseDate(val, 'dd/MM/yyyy') + ", 23:59:59", "dd/MM/yyyy, HH:mm:ss");
          this.endDate = endDate ? endDate.getTime() : null;
          this.broadcastChange$.next(true);
        }),
        this.breakpointObserver
        .observe([Breakpoints.XSmall]) // Breakpoints.XSmall tương ứng với chiều rộng < 576px
        .subscribe((result) => {
          this.isDevice = result.matches;
        })
      ],
    ];
    this.setDefault();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.startDate) {
      console.log("changes startDate: ", changes.startDate.currentValue);
      this.setDate("startDate", changes.startDate.currentValue);
    }
    if (changes.endDate) {
      this.setDate("endDate", changes.endDate.currentValue);
    }
  }
  ngOnDestroy() {}
  setDefault() {
    if (!this.isDefaultData) {
      return;
    }
    let date = DateUtil.getCurrentDateNoTime();
    this.endDate = date.getTime();
    this.setDate("endDate", date);
    const startDate = DateUtil.revertDate(`01-01-${date.getFullYear()}`, 'dd-MM-yyyy');
    this.startDate = startDate.getTime();
    this.setDate("startDate", this.startDate);
  }
  setDate(field, date): void {
    // Set today date using the setValue function
    this.formDate.patchValue({
      [field]: date
    });
  }
  emitInputDate(field, text) {
    this.formDate.patchValue({
      [field]: text,
    });
  }
  checkValidDate() {
    const startDate = this.startDate;
    const endDate = this.endDate;

    if (startDate && endDate && startDate > endDate) {
      const endDate = this.startDate
        ? DateUtil.parseDate(new Date(this.startDate), "yyyyMMdd") +
          ", 23:59:59"
        : null;
      this.endDate = endDate
        ? DateUtil.revertDate(endDate, "yyyyMMdd, HH:mm:ss").getTime()
        : null;
      this.setDate("endDate", startDate);
    }
  }
  broadcastData() {
    this.eventManager.broadcast({
      name: "change-filter-start-end-date",
      content: this.emitData(),
    });
  }
  emitData() {
    this.checkValidDate();
    return {
      startDate: this.startDate || undefined,
      endDate: this.endDate || undefined,
    };
  }
  startDateNow() {
    document.getElementById("start-date").classList.toggle("active");
  }
  endDateNow() {
    document.getElementById("end-date").classList.toggle("active");
  }
}
